import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { forgotPassword } from '../api'
import Button from '../components/Button'
import Input from '../components/Input'
import { ErrorAlert, SuccessAlert } from '../components/Alert'
import { useDocumentTitle } from '../components/PublicLayout'
import AuthHeader from '../components/AuthHeader'

export default function ForgotPassword() {
  useDocumentTitle('Reset your password')
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sentMsg, setSentMsg] = useState('')
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    setSentMsg('')
    setLoading(true)
    try {
      const res = await forgotPassword(email)
      setSentMsg(res.message || 'If an account exists, a reset link is on its way.')
    } catch (err) {
      setError(err.message || 'Could not send the email. Please try again shortly.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <AuthHeader subtitle="Reset your password" />

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8">
          <p className="text-sm text-gray-600 mb-4">
            Enter the email on your account and we'll send you a link to set a new
            password. The link is valid for 1 hour.
          </p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Email"
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="director@nonprofit.org"
            />
            <Button type="submit" loading={loading} className="w-full">
              Send reset link
            </Button>
            <SuccessAlert message={sentMsg} />
            <ErrorAlert message={error} />
          </form>
        </div>

        <p className="text-center text-xs text-gray-500 mt-6">
          <Link to="/signin" className="text-brand-500 hover:underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  )
}
